// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"0235988e","498":"053976ea","703":"0b1c3a6d","787":"72f87496"}[chunkId] + ".chunk.js";
};